import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { OrderSelectionService } from 'src/app/selection/order-selection.service';

@Component({
  selector: 'app-checkbox-renderer',
  templateUrl: './checkbox-renderer.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  private orderSelectionService = inject(OrderSelectionService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private params!: ICellRendererParams;
  private orderId!: string;
  public isChecked!: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this.orderSelectionService.singleSelectionChange$
      .pipe(
        takeUntil(this.destroy$),
        tap((selection: boolean) => {
          this.isChecked =
            this.isChecked !== selection && selection != null
              ? selection
              : this.isChecked;
          this.changeDetectorRef.markForCheck();
          return this.isChecked;
        }),
        filter(() => !!this.params),
        filter((selection) => null != selection),
      )
      .subscribe((selection) => {
        this.params.data.selected = selection;
        this.params.api.getRowNode(this.orderId)?.setSelected(selection);
      });
  }

  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.orderId = params.data.id;
    this.isChecked = params.data.selected;
    this.params.api.getRowNode(this.orderId)?.setSelected(this.isChecked);
  }

  public changeSelection(): void {
    this.toggleSelection();
    this.orderSelectionService
      .changeOrderSelection(this.orderId, this.isChecked)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: () => {
          this.toggleSelection();
        },
      });
  }

  private toggleSelection(): void {
    this.isChecked = !this.isChecked;
    this.params.data.selected = this.isChecked;
    this.params.api.getRowNode(this.orderId)?.setSelected(this.isChecked);
    this.changeDetectorRef.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
